import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getModel } from './selectors';
import * as actions from './actions';
import SerialNumberEditorComponent from './SerialNumberEditorComponent';

const SerialNumberEditorContainer = (props) => {
    return <SerialNumberEditorComponent {...props} />;
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const SerialNumberEditorContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(SerialNumberEditorContainer);

export default React.memo(SerialNumberEditorContainerConn);
